import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { realtimeDb } from "../services/firebase";
import { ref, onValue, remove } from "firebase/database";

export function DraftsList({ userId, practice }) {
  const [drafts, setDrafts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!userId || !practice?.fields?.slug) return;
    const draftsRef = ref(realtimeDb, `/caseDrafts/${userId}`);
    const unsubscribe = onValue(draftsRef, (snapshot) => {
      const val = snapshot.val();
      if (val) {
        const arr = Object.values(val)
          .filter((draft) => draft.practiceSlug === practice.fields.slug)
          .sort((a, b) => b.lastUpdated - a.lastUpdated);
        setDrafts(arr);
      } else {
        setDrafts([]);
      }
    });
    return () => unsubscribe();
  }, [userId, practice?.fields?.slug]);

  function handleDelete(draft) {
    if (!userId || !draft.draftId) return;
    if (!window.confirm("Are you sure you want to delete this draft?")) return;
    const draftRef = ref(realtimeDb, `/caseDrafts/${userId}/${draft.draftId}`);
    remove(draftRef);
    setDrafts((prev) => prev.filter((d) => d.draftId !== draft.draftId));
  }

  return (
    <div className="mb-3">
      <div className="table-overflow">
        <table className="cases-table" data-cy="drafts-table">
          <thead>
            <tr>
              <th>Pet Name</th>
              <th>Species</th>
              <th>Owner Name</th>
              <th>Aquamation Type</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {drafts.map((draft) => (
              <tr
                key={draft.draftId}
                onClick={() =>
                  navigate(`/${practice.fields.slug}/draft/${draft.draftId}`)
                }
              >
                <td>{draft.formData.petName} </td>
                <td>{draft.formData.species}</td>
                <td>{draft.formData.ownerName}</td>
                <td>{draft.formData.aquamationType}</td>
                <td className="text-right">
                  <button
                    className="button button-red-500 spaced"
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      handleDelete(draft);
                    }}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {drafts.length === 0 && (
        <div className="mt-2">
          No draft cases found. Click the new case button above to start a new
          case.
        </div>
      )}
    </div>
  );
}
